interface GoogleMapLinkParameters {
  longitude: number | string
  latitude: number | string
}

const createGoogleMapLink = (parameters: GoogleMapLinkParameters) => {
  const { longitude, latitude } = parameters

  return `https://maps.google.com/?q=${latitude},${longitude}`
}

export default createGoogleMapLink
